import PostsUser from './PostsUser';

export default PostsUser;
